import React, { useEffect, useState } from "react";
import { MessageCircle, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminOrderWhatsapp, adminMarkWhatsappSent } from "../../api";

const STEPS = [
  { kind: "confirmed", label: "Order confirmed" },
  { kind: "shipped", label: "Order shipped" },
  { kind: "delivered", label: "Order delivered" },
];

export const WhatsAppUpdates = ({ order }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    adminOrderWhatsapp(order.id).then(setData).catch(() => toast.error("Could not load WhatsApp messages"));
  }, [order.id, order.status, order.tracking_url]);

  const send = async (kind) => {
    window.open(data.links[kind].url, "_blank", "noopener");
    try {
      const r = await adminMarkWhatsappSent(order.id, kind);
      setData((d) => ({ ...d, links: { ...d.links, [kind]: { ...d.links[kind], sent_at: r.sent_at } } }));
    } catch (e) { /* message still opened */ }
  };

  if (!data) return <Loader2 className="w-4 h-4 animate-spin text-[var(--copper)]" />;

  return (
    <div data-testid="admin-whatsapp-updates">
      <p className="text-xs tracking-[0.2em] uppercase text-[var(--espresso)]/60 mb-2">WhatsApp updates</p>
      {!data.opt_in ? (
        <p data-testid="admin-whatsapp-not-opted" className="text-sm text-[var(--espresso)]/60">Customer did not opt in to WhatsApp updates.</p>
      ) : (
        <div className="space-y-2">
          {!data.phone_valid && (
            <p data-testid="admin-whatsapp-phone-warning" className="text-xs text-red-700">This phone number looks incomplete. Check it before sending.</p>
          )}
          {STEPS.map(({ kind, label }) => {
            const sentAt = data.links[kind].sent_at;
            return (
              <div key={kind} className="flex items-center justify-between gap-3 border border-[var(--sand)] bg-white px-4 py-2.5">
                <div>
                  <p className="text-sm">{label}</p>
                  {sentAt && (
                    <p data-testid={`admin-whatsapp-${kind}-sent`} className="text-[11px] text-[var(--espresso)]/50 flex items-center gap-1">
                      <Check className="w-3 h-3" /> Opened {new Date(sentAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
                    </p>
                  )}
                </div>
                <button type="button" onClick={() => send(kind)} data-testid={`admin-whatsapp-${kind}-btn`} className="h-9 px-4 bg-[#075E54] hover:bg-[#128C7E] text-white text-[10px] tracking-[0.18em] uppercase inline-flex items-center gap-2 transition-colors">
                  <MessageCircle className="w-3.5 h-3.5" /> {sentAt ? "Send again" : "Send"}
                </button>
              </div>
            );
          })}
          {!order.tracking_url && !order.awb_code && (
            <p className="text-[11px] text-[var(--espresso)]/50">No tracking number yet, so the "shipped" message won't include a tracking link.</p>
          )}
        </div>
      )}
    </div>
  );
};
